export default __webpack_public_path__ + "static/media/laundry2-beforeB-480w.49d4510d.avif";